module.exports = __webpack_public_path__ + "img/male_user.fecf1cc9.svg";